module.exports = __webpack_public_path__ + "mx.svg?7fd6e432473edd8abb2611ae2ce5dad3";